import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export default function apidocsRoutes($stateProvider: StateProvider) {
    let apidocsModule: { default: any; };
    $stateProvider
        .state({
            name: 'apidocs',
            url: '/apidocs',
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => apidocsModule.default,
            },
            lazyLoad: async () => {
                apidocsModule = await import(/* webpackChunkName: "apidocs" */ './KpApidocsPage.svelte');
                return null;
            }
        });
}
